// export default function init() {
document.addEventListener('DOMContentLoaded', function () {
  let posts_filter_links = document.querySelectorAll('#category-filter');
  let posts_filter_columns = document.querySelectorAll('#post-container');
  const postsVisible = parseInt(document.querySelector('#posts-grid')?.dataset.articlesCount, 10) || 21;

  if (posts_filter_links) {
    posts_filter_links.forEach(function (posts_filter_link) {
      posts_filter_link.addEventListener('click', function (event) {
        event.preventDefault();

        const isAll = posts_filter_link.dataset.filter === 'all';

        if (isAll) {
          posts_filter_links.forEach(link => link.classList.remove('active'));
          posts_filter_link.classList.add('active');

          posts_filter_columns.forEach((column, index) => {
            if (index < postsVisible) {
              column.classList.remove('hidden');
            } else {
              column.classList.add('hidden');
            }
          });
        } else {
          posts_filter_link.classList.toggle('active');

          // Якщо інші фільтри активні, прибрати "all"
          posts_filter_links.forEach(link => {
            if (link.dataset.filter === 'all') link.classList.remove('active');
          });

          let posts_filter_links_active = document.querySelectorAll('#category-filter.active');

          if (posts_filter_links_active.length > 0) {
            posts_filter_columns.forEach(column => column.classList.add('hidden'));

            posts_filter_links_active.forEach(activeLink => {
              posts_filter_columns.forEach(column => {
                if (column.dataset.filtercolumn === activeLink.dataset.filter) {
                  column.classList.remove('hidden');
                }
              });
            });
          } else {
            posts_filter_columns.forEach((column, index) => {
              if (index < postsVisible) {
                column.classList.remove('hidden');
              } else {
                column.classList.add('hidden');
              }
            });
          }
        }

        // Оновлюємо видимість кнопки після фільтрації
        updateButtonVisibility();
      });
    });
  }

  //search posts
  const searchInput = document.querySelector('#search');
  const postsColumns = document.querySelectorAll('#post-container');
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      const searchTerm = this.value.trim().toLowerCase();

      postsColumns.forEach(column => {
        const category = column.querySelector('#category')?.textContent.toLowerCase() || '';
        const title = column.querySelector('.post-title')?.textContent.toLowerCase() || '';

        if (category.includes(searchTerm) || title.includes(searchTerm)) {
          column.classList.remove('hidden');
        } else {
          column.classList.add('hidden');
        }
      });

      // Оновлюємо видимість кнопки після пошуку
      updateButtonVisibility();
    });
  }
  // Posts "Show More" Button Handler
  const postContainers = document.querySelectorAll('#post-container');
  const btnMore = document.querySelector('#button-more');

  // Initialize on page load
  if (btnMore && postContainers.length >= 0) {
    if (postContainers.length === 0 || postContainers.length <= postsVisible) {
      btnMore.classList.add('hidden');
    }

    // Show more posts on button click
    btnMore.addEventListener('click', function (e) {
      e.preventDefault();

      // Show all hidden posts
      postContainers.forEach(function (post) {
        if (post.classList.contains('more')) {
          post.classList.remove('hidden');
        }
      });

      // Hide the button after showing all posts
      btnMore.classList.add('hidden');
    });
  }

  function updateButtonVisibility() {
    if (!btnMore || postContainers.length === 0) return;

    // Count visible posts
    const visiblePosts = Array.from(postContainers).filter(post => !post.classList.contains('hidden'));

    // Count posts with 'more' class that are still hidden
    const hiddenMorePosts = Array.from(postContainers).filter(
      post => post.classList.contains('hidden') && post.classList.contains('more')
    );

    const screenWidth = window.innerWidth;
    let postsPerView;

    // Determine posts per view based on screen width
    if (screenWidth >= 1280) {
      // xl breakpoint
      postsPerView = 6; // 2 rows × 3 columns
    } else if (screenWidth >= 640) {
      // sm breakpoint
      postsPerView = 4; // 2 rows × 2 columns
    } else {
      postsPerView = 3; // 3 rows × 1 column
    }

    // Show button only if there are hidden posts with 'more' class
    if (hiddenMorePosts.length > 0 && visiblePosts.length < postContainers.length) {
      btnMore.classList.remove('hidden');
    } else {
      btnMore.classList.add('hidden');
    }
  }

  // Call on page load and window resize
  if (typeof updateButtonVisibility === 'function') {
    updateButtonVisibility();
    window.addEventListener('resize', updateButtonVisibility);
  }
});